export enum AspectCode {
  Accounting = "acc",
  AIBookkeeper = "aib",
  AdvancedLedger = "adv",
  AdvancedQualityControl = "adq",
  AskDigits = "ask",
  Audit = "adt",
  AuditLog = "aud",
  AutomatedBankRecs = "abr",
  AutomatedQualityControl = "aqc",
  AutomatedReceiptHandling = "arh",
  BankRecChecklist = "brc",
  BanksAndCards = "bnc",
  BillsManagement = "bmg",
  Budgets = "bud",
  Canvas = "cvs",
  CategoryManager = "cmg",
  ClosedPeriod = "clp",
  ClosedPeriodReviewQueue = "cpr",
  Connections = "cnx",
  CustomerDirectory = "cdr",
  DimensionManager = "dmg",
  Employments = "emp",
  ExternallyManagedPayments = "xmp",
  Financials = "fin",
  FirmBranding = "fbg",
  MultipleDemoClients = "mdc",
  FirmLevelPredictions = "flp",
  FutureDatedTransactions = "fdt",
  Collect = "gpd", // Formerly Get Paid
  Home = "hom",
  InvoiceCreditCards = "icc",
  InvoiceManualBankAccount = "imb",
  Invoicing = "inv",
  MultiCustomDashboards = "mcd",
  OrganizationClientManagement = "ocp",
  PayBills = "pbl",
  ProductAnalytics = "pal",
  QuarterlyDashboard = "qtr",
  Reports = "rpt",
  RestrictLedgerEdits = "rle",
  Schedules = "sch",
  Sharing = "shr",
  SSOEmailSuppression = "ses",
  SSOUserCreation = "sso",
  StripeConnectorV2Upgrade = "s2u",
  TransactionActionItems = "tai",
  Upsells = "ups",
  Vault = "vlt",
  VendorDirectory = "vdr",
  VendorManagement = "vmg",
  VendorManagementView = "vmv",
  Webhooks = "whk",
}
